var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4B0082"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 28.9582H17.4998C12.9748 28.9582 11.0415 27.0248 11.0415 22.4998V17.4998C11.0415 12.9748 12.9748 11.0415 17.4998 11.0415H22.4998C27.0248 11.0415 28.9582 12.9748 28.9582 17.4998V22.4998C28.9582 27.0248 27.0248 28.9582 22.4998 28.9582ZM17.4998 12.2915C13.6582 12.2915 12.2915 13.6582 12.2915 17.4998V22.4998C12.2915 26.3415 13.6582 27.7082 17.4998 27.7082H22.4998C26.3415 27.7082 27.7082 26.3415 27.7082 22.4998V17.4998C27.7082 13.6582 26.3415 12.2915 22.4998 12.2915H17.4998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 23.5418C18.0502 23.5418 16.4585 21.9502 16.4585 20.0002C16.4585 18.0502 18.0502 16.4585 20.0002 16.4585C21.9502 16.4585 23.5418 18.0502 23.5418 20.0002C23.5418 21.9502 21.9502 23.5418 20.0002 23.5418ZM20.0002 17.7085C18.7335 17.7085 17.7085 18.7335 17.7085 20.0002C17.7085 21.2668 18.7335 22.2918 20.0002 22.2918C21.2668 22.2918 22.2918 21.2668 22.2918 20.0002C22.2918 18.7335 21.2668 17.7085 20.0002 17.7085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 16.2499C24.0585 16.2499 23.9502 16.2249 23.8502 16.1833C23.7502 16.1416 23.6585 16.0833 23.5752 16.0083C23.5002 15.9249 23.4335 15.8333 23.3918 15.7333C23.3502 15.6333 23.3335 15.5249 23.3335 15.4166C23.3335 15.3083 23.3502 15.1999 23.3918 15.0999C23.4418 14.9916 23.5002 14.9083 23.5752 14.8249C23.6168 14.7916 23.6585 14.7499 23.7002 14.7249C23.7502 14.6916 23.8002 14.6666 23.8502 14.6499C23.9002 14.6249 23.9502 14.6083 24.0085 14.5999C24.2752 14.5416 24.5585 14.6333 24.7585 14.8249C24.8335 14.9083 24.8918 14.9916 24.9335 15.0999C24.9752 15.1999 25.0002 15.3083 25.0002 15.4166C25.0002 15.5249 24.9752 15.6333 24.9335 15.7333C24.8918 15.8333 24.8335 15.9249 24.7585 16.0083C24.6752 16.0833 24.5835 16.1416 24.4835 16.1833C24.3835 16.2249 24.2752 16.2499 24.1668 16.2499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48);
export default __webpack_public_path__ + "static/media/Frame 48.cfd8b444e64cfa202b4bbcdd0ebf4caa.svg";
export { ForwardRef as ReactComponent };